import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';

import { Icon } from '@lanl-web/lanl-components';
import './LocalNavDesktop.scss';

export const LocalNavDesktop = ({ menuItems, activeItem, setActiveItem }) => {
  return (
    <div className='local-nav-desktop'>
      {menuItems.map(({ name, slug, page }, index) => {
        const isActive = activeItem === slug ? 'active' : '';

        if (slug === 'home') {
          return (
            <div
              className={`local-nav-item ${isActive}`}
              onClick={() => window.location.replace('/')}
              key={slug + index}
            >
              {name}
              <Icon icon='chevron-down' size='xs' className='ml-2 chevron' />
            </div>
          );
        } else {
          return (
            <div
              className={`local-nav-item ${isActive}`}
              onClick={() => setActiveItem(slug)}
              key={slug + index}
            >
              {name}
              <Icon icon='chevron-down' size='xs' className='ml-2 chevron' />
              <div className={`local-nav-dropdown ${isActive}`}>
                <Link
                  className='local-nav-dropdown-item'
                  to={`/${slug}/`}
                  key={index + slug}
                >
                  {name}
                </Link>
                {page.map(({ slug: pageSlug, title }, index) => (
                  <Link
                    className='local-nav-dropdown-item'
                    to={`/${slug}/${pageSlug}`}
                    key={index + slug}
                  >
                    {title}
                  </Link>
                ))}
              </div>
            </div>
          );
        }
      })}
    </div>
  );
};

LocalNavDesktop.defaultProps = {
  menuItems: [],
};

LocalNavDesktop.propTypes = {
  activeItem: PropTypes.string,
  menuItems: PropTypes.array,
  setActiveItem: PropTypes.func,
};

export default LocalNavDesktop;
